import { fetchWithReporter, reportError } from '@americanexpress/one-identity-ducks';
import { clearUserSessionResult } from './procedures';
import { isLogSuccess } from './selectors';

// eslint-disable-next-line consistent-return -- this is a fire and forget
export default async function endClientSession({ dispatch, getState }) {
  try {
    const state = getState();
    const url = `${state.getIn(['config', 'faasApiUrl'])}/DeleteUserSession.v1`;
    const errorReporter = (error, otherData) => dispatch(
      reportError(error, {
        ...otherData,
        collectionMethod: 'endClientSession',
      })
    );

    await fetchWithReporter(
      url,
      {
        method: 'GET',
        credentials: 'include',
        timeout: 9e3,
        logSuccess: isLogSuccess(state),
        retryCount: 5,
        errorReporter,
      },
      state
    );
    return dispatch(clearUserSessionResult);
  } catch (error) {
    // fire and forget
  }
}

export const endClientSessionHook = ({ dispatch, getState }) => async (nextState, replace, callback) => {
  if (global.BROWSER) {
    await endClientSession({ dispatch, getState });
  }
  callback();
};
